import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminPost } from '../api/apiClient';
import './admin.scss';

export function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState(null);
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await adminPost('/admin/login.php', { username, password });
      onLogin && onLogin();
      navigate('/admin/blogs');
    } catch (err) {
      setError(err.status === 401 ? 'Nieprawidłowe dane logowania.' : 'Błąd serwera. Spróbuj ponownie.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login__card">
        <div className="admin-login__logo-mark">
          <div className="admin-login__mark">P</div>
        </div>
        <h1 className="admin-login__title">Panel admina</h1>
        <p className="admin-login__subtitle">Kancelaria Radcy Prawnego</p>

        {error && <div className="admin-login__error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="admin-login__field">
            <label htmlFor="al-username">Login</label>
            <input
              id="al-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </div>
          <div className="admin-login__field">
            <label htmlFor="al-password">Hasło</label>
            <input
              id="al-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button type="submit" className="admin-login__btn" disabled={loading}>
            {loading ? 'Logowanie…' : 'Zaloguj się'}
          </button>
        </form>
      </div>
    </div>
  );
}
